
export default {
  name: 'BaseExpandablePanel',
  props: {
    title: {
      type: String,
      default: '',
    },

    more: {
      type: String,
      default: 'More',
    },

    less: {
      type: String,
      default: 'Less',
    },

    isFaq: {
      type: Boolean,
      default: false,
    },

    isSearchTooltip: {
      type: Boolean,
      default: false,
    },

    checkoutRegistration: {
      type: Boolean,
      default: false,
    },

    vendorName: {
      type: String,
      default: '',
    },
  },

  data () {
    return {
      isOpen: false,
    }
  },

  methods: {
    toggle () {
      this.isOpen = !this.isOpen
    },
  },
}
